import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { ICategoryOrProductItem } from '../../CategoryAndProductModal';
import { getTranslate } from 'src/utils/helpers';

interface IProps {
  item?: ICategoryOrProductItem;
  active?: boolean;
  noAvailable?: boolean;
  clickItem: (item?: ICategoryOrProductItem) => void;
}

export default class CategoryAndProductModalItem extends React.Component<IProps, {}> {
  clickItem = () => {
    if (this.props.noAvailable) return;

    this.props.clickItem(this.props.item);
  };

  get className(): string {
    let className: string = 'custom-modal__item mb-2 mr-2';
    if (this.props.active) className += ' custom-modal__item_active';
    if (this.props.noAvailable) className += ' custom-modal__item_no-available';
    return className;
  }

  render() {
    return (
      <>
        {this.props.item ? (
          <li className={this.className} onClick={this.clickItem}>
            <div className="custom-modal__item__name-wrapper px-3">
              <p className="custom-modal__item__name">{getTranslate(this.props.item.name)}</p>
            </div>
          </li>
        ) : (
          <div className="custom-modal__item custom-modal__item__skeleton mb-2 mr-2">
            <Skeleton width="100%" height="100%" />
          </div>
        )}
      </>
    );
  }
}
